// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-code[data-v-fc3145b2]{display:flex}.input-code__item[data-v-fc3145b2]{text-align:center}.input-code__item+.input-code__item[data-v-fc3145b2]{margin-left:10px}.input-code[data-v-fc3145b2] .el-input__inner{text-align:center}", ""]);
// Exports
module.exports = exports;
